import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const OpportunitySubCategoryInput = () => {
  const { subcategoryId = '' } = useParams();
  const decodedId = subcategoryId ? atob(subcategoryId) : subcategoryId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunitySubCategory';

  useEffect(() => {
    if (subcategoryId) { setIsEditing(true); fetchDetails(); }
  }, [subcategoryId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['opportunitySubCategory'] + id + '/', { headers });
      setFormData(response.data?.data ?? response.data);
    } catch (error) { console.error('Error fetching Opportunity Sub-Category details:', error); }
  };

  const fields = [{"name":"name","label":"Name","type":"text"},{"name":"description","label":"Description","type":"textarea"},{"name":"category","label":"Category","type":"number"}];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Sub-Category' : 'Create Opportunity Sub-Category'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunitySubCategoryInput;